import ReactTable from 'react-table';
import React from 'react';
import PropTypes from 'prop-types';

// Local Deps
import './TechInfo.scss';
import { columns } from './gridConfig';
import makeTechInfoObj from './makeTechInfoObj';

export default class TechInfoGrid extends React.PureComponent {
  static propTypes = {
    techInfoText: PropTypes.string.isRequired,
  };

  render() {
    const { techInfoText } = this.props;
    const techInfo = makeTechInfoObj(techInfoText)

    return (
      <div className="nf-tech-info__grid">
        <ReactTable
          data={techInfo}
          columns={columns}
          defaultPageSize={techInfo.length < 5 ? techInfo.length : 5}
          showPagination={techInfo.length > 5}
          noDataText={techInfo.length ? 'No Data Found' : null}
          style={{ textAlign: 'center' }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/grids/TechInfoGrid/TechInfoGrid.jsx